import { render, staticRenderFns } from "./ayuda-item.vue?vue&type=template&id=6ef8c436&scoped=true&"
import script from "./ayuda-item.vue?vue&type=script&lang=ts&"
export * from "./ayuda-item.vue?vue&type=script&lang=ts&"
import style0 from "./ayuda-item.vue?vue&type=style&index=0&id=6ef8c436&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef8c436",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDialog,VRow})
